import { validateToken } from "../api/authentication";

async function isLoggedIn() {
  const res = await validateToken();
  if (!res) window.location.href = "/auth/login";
}

export default isLoggedIn;
